import { FC, ReactNode } from 'react';
import { DigitalFormsTypes } from '@frontend/api-digital-forms';
import TemplatePreviewBody from './preview-body/preview-body.component';
import TemplatePreviewHeader from './preview-header/preview-header.component';
import { TemplatePreviewWrapper } from './provider';
import { containerStyle } from './template-preview.style';

interface TemplatePreviewProps {
  children: ReactNode;
  template: DigitalFormsTypes.Schema.Template;
}

const _TemplatePreview: FC<TemplatePreviewProps> = ({ children, template }) => {
  return (
    <TemplatePreviewWrapper template={template}>
      <div css={containerStyle}>{children}</div>
    </TemplatePreviewWrapper>
  );
};

_TemplatePreview.displayName = 'TemplatePreview';

export const TemplatePreview = Object.assign(_TemplatePreview, {
  Header: TemplatePreviewHeader,
  Body: TemplatePreviewBody,
});
